export default __webpack_public_path__ + "static/phone-therapy-e410a8c6ec557feda9743fb09cc6e9ee.webp";